/**
 * Slow editorial marquee — repeats the phrase seamlessly.
 * Uses CSS keyframes for perf; opacity is toned so it feels like a whisper.
 */
export default function Marquee({
  items = [
    "মাটির স্বাদ",
    "Handmade in Bengal",
    "Founding Vendor",
    "Authentic Bengal",
    "নিজস্ব ব্র্যান্ড",
    "Slow Commerce",
  ],
  className = "",
}) {
  const line = items.join("   ·   ");
  return (
    <div
      className={`w-full overflow-hidden select-none ${className}`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track font-editorial italic text-3xl md:text-5xl lg:text-6xl text-[color:var(--sbh-mustard)]/70">
        <span>{line}   ·   </span>
        <span>{line}   ·   </span>
      </div>
    </div>
  );
}
